import FixOrUpgradeAction from '@/classes/SubmissionActions/FixOrUpgradeAction'
import { BaseEverplansStatus } from '@/classes/SubmissionStatuses/BaseEverplansStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { type SubmissionAction } from '@/classes/SubmissionStatuses/types'

export default class EmailAndPaymentError extends BaseEverplansStatus {
	getActions(): Array<SubmissionAction> {
		return [
			new FixOrUpgradeAction(
				this.submissionStatus.emailStatus!.status, // emailFailed confirms emailStatus is set
				this.submissionStatus.requestedAccountTier,
				this.submissionStatus.lastSubmittedEmail,
				this.submissionStatus.paymentAmount
			),
		]
	}

	getStatusText() {
		return 'Invalid Email/Payment'
	}

	getToolTipText() {
		return {
			title: this.getStatusText(),
			body: 'There are issues with this email and payment method. Click Fix button to update both. Have questions? Contact salesstudio@precoa.com.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
